module.exports = __webpack_public_path__ + "static/media/p001.ce7882ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/p001.jpg
// module id = 1514
// module chunks = 0